import { START_PREP_MODE, STOP_PREP_MODE, START_CLEAN_MODE, CLOCK_OUT, UPDATE_ELAPSED_TIME, START_BREAK, END_BREAK, UPDATE_PREV_SECONDS, UPDATE_START_TIME } from '../actions/PrepActions';

const initialState = {
    inPrepMode: false,
    tmName: '',
    date: '',
    elapsedTime: '00:00:00',
    inCleanMode: false,
    startTime: null,
    previous_seconds: '00:00:00',
    onBreak: false,
};

const PrepReducer = (state = initialState, action) => {
    switch (action.type) {
        case START_PREP_MODE:
            return {
                ...state,
                inPrepMode: true,
                tmName: action.payload.tmName,
                date: action.payload.date,
                elapsedTime: '00:00:00',
                startTime: Date.now()
            };
        case STOP_PREP_MODE:
            return {
                ...state,
                inPrepMode: false,
                elapsedTime: '00:00:00',
                startTime: null
            };
        case START_CLEAN_MODE:
            return {
                ...state,
                inCleanMode: true,
                startTime: Date.now(),  // Reset startTime to now when starting clean mode
                elapsedTime: '00:00:00',
                // startTime: state.startTime || Date.now()
            };
        case CLOCK_OUT:
            return {
                ...state,
                inCleanMode: false,
                previous_seconds: '00:00:00',  // Reset previous seconds
                elapsedTime: '00:00:00',  // Optionally reset elapsed time
                startTime: null,  // Reset startTime
            };
        case UPDATE_ELAPSED_TIME:
            return {
                ...state,
                elapsedTime: action.payload,
            };
        case START_BREAK:
            return {
                ...state,
                onBreak: true,
                elapsedTime: action.payload,
                previous_seconds: action.payload,
                startTime: null
            };
        case END_BREAK:
            return {
                ...state,
                onBreak: false,
                startTime: Date.now(),
            };
        case UPDATE_PREV_SECONDS:
            return {
                ...state,
                previous_seconds: action.payload,
            };

        case UPDATE_START_TIME:
            return {
                ...state,
                startTime: action.payload,
            };
        default:
            return state;
    }
};

export default PrepReducer;
